import _classCallCheck from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/vintharas/GitHub/barbarianmeetscoding/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import Map from "./map.js";
/**
 * @class Dungeon map: has rooms and corridors
 * @augments ROT.Map
 */
var Dungeon = /*#__PURE__*/function (_Map) {
  _inherits(Dungeon, _Map);
  var _super = _createSuper(Dungeon);
  function Dungeon(width, height) {
    var _this;
    _classCallCheck(this, Dungeon);
    _this = _super.call(this, width, height);
    _this._rooms = [];
    _this._corridors = [];
    return _this;
  }
  /**
   * Get all generated rooms
   * @returns {ROT.Map.Feature.Room[]}
   */
  _createClass(Dungeon, [{
    key: "getRooms",
    value: function getRooms() {
      return this._rooms;
    }
    /**
     * Get all generated corridors
     * @returns {ROT.Map.Feature.Corridor[]}
     */
  }, {
    key: "getCorridors",
    value: function getCorridors() {
      return this._corridors;
    }
  }]);
  return Dungeon;
}(Map);
export { Dungeon as default };